import axios from "axios";
import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { baseURL } from "../../Config";
import { MANUAL_RESET_API, PROFILE_API } from "../../Helper/ApiPath";
import { RESET_PASSWORD, CONFIRM, CONFIRM_PASSWORD, HOME, NEW_PASSWORD, NAME, MANUAL_RESET_PASSWORD } from "../../Helper/Constants";
import { ENTER_NEW_PASSWORD, PASSWORD_DOES_NOT_MATCH, PASSWORD_ERROR_TEXT } from "../../Helper/Messages";

function ManualResetPassword() {
    const token = JSON.parse(localStorage.getItem("logToken"));

    let doctorId = localStorage.getItem("doctorId");
    const [profileInfo, setProfileInfo] = useState([]);

    const [newPasswordShown, setNewPasswordShown] = useState(false);
    const [conPasswordShown, setConPasswordShown] = useState(false);
    const [pwdError, setPwdError] = useState(false);
    const [password, setPassword] = useState({
        newPassword: "",
        confirmPassword: "",
    });
    const navigate = useNavigate();

    const toggleNewPassword = () => {
        setNewPasswordShown(!newPasswordShown);
    };

    const toggleConPassword = () => {
        setConPasswordShown(!conPasswordShown);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPassword({ ...password, [name]: value });
    };

    const fetchData = async () => {
        await axios
            .get(`${baseURL}/${PROFILE_API}/${doctorId}`, {
                headers: { authorization: token.token },
            })
            .then((res) => {
                setProfileInfo(res.data.data);
            })
            .catch((err) => {
                if (err.response) {
                    if (err.response.status == 500) {
                        localStorage.clear();
                        navigate("/login");
                    } else {
                        toast.error(err.response.data.message);
                    }
                }
            });
    };

    const handleClick = () => {
        const validPassword = new RegExp("^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})");

        if (!password.newPassword) {
            toast.error(ENTER_NEW_PASSWORD);
        } else if (!validPassword.test(password.newPassword)) {
            setPwdError(true);
        } else if (password.newPassword !== password.confirmPassword) {
            toast.error(PASSWORD_DOES_NOT_MATCH);
        } else {
            axios
                .post(`${baseURL}/${MANUAL_RESET_API}`, {
                    headers: { authorization: token.token },
                    doctorId: doctorId,
                    newPassword: password.newPassword,
                })
                .then((res) => {
                    toast.success(res.data.message);
                    setPassword({
                        email: "",
                        newPassword: "",
                        confirmPassword: "",
                    });
                    setPwdError(false);
                })
                .catch((err) => {
                    if (err.response) {
                        if (err.response.status == 500) {
                            localStorage.clear();
                            navigate("/login");
                        } else {
                            toast.error(err.response.data.message);
                        }
                    }
                });
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <>
            <div className="page-content-wrapper">
                <div className="page-content">
                    <div className="page-bar">
                        <div className="page-title-breadcrumb">
                            <div className=" pull-left">
                                <div className="page-title">{MANUAL_RESET_PASSWORD}</div>
                            </div>
                            <ol className="breadcrumb page-breadcrumb pull-right">
                                <li>
                                    <i className="fa fa-home"></i>&nbsp;
                                    <NavLink className="parent-item" to="/dashboard">
                                        {HOME}
                                    </NavLink>
                                    &nbsp;<i className="fa fa-angle-right"></i>
                                </li>
                                <li className="active">{MANUAL_RESET_PASSWORD}</li>
                            </ol>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-md-6 col-sm-6">
                            <div className="card card-box">
                                <div className="card-head">
                                    <header>{MANUAL_RESET_PASSWORD}</header>
                                </div>
                                <div className="card-body " id="bar-parent">
                                    <form>
                                        <div className="form-group">
                                            <i className="fa fa-envelope font-left " aria-hidden="true"></i>
                                            <span>{NAME}</span>
                                            <div style={{ display: "flex" }}>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="txtemail"
                                                    name="email"
                                                    value={`${profileInfo.firstName} ${profileInfo.lastName} (${profileInfo.email})`}
                                                    disabled
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <i className="fa fa-lock font-left " aria-hidden="true"></i>
                                            <span>{NEW_PASSWORD}</span>
                                            <span className="requireField"> * </span>
                                            <div style={{ display: "flex" }}>
                                                <input
                                                    type={newPasswordShown ? "text" : "password"}
                                                    className="form-control"
                                                    id="password"
                                                    name="newPassword"
                                                    placeholder="Enter Password"
                                                    value={password.newPassword}
                                                    onChange={handleChange}
                                                />
                                                <i className={newPasswordShown ? "input-group-text fa fa-eye" : "input-group-text fa fa-eye-slash"} id="basic-addon1" onClick={toggleNewPassword}></i>
                                            </div>

                                            {pwdError === false ? <p style={{ fontSize: "10px", color: "grey" }}>{PASSWORD_ERROR_TEXT}</p> : <p className="txtError">{PASSWORD_ERROR_TEXT}</p>}
                                        </div>

                                        <div className="form-group">
                                            <i className="fa fa-lock font-left " aria-hidden="true"></i>
                                            <span>{CONFIRM_PASSWORD}</span>
                                            <span className="requireField"> * </span>

                                            <div style={{ display: "flex" }}>
                                                <input
                                                    type={conPasswordShown ? "text" : "password"}
                                                    className="form-control"
                                                    id="password"
                                                    name="confirmPassword"
                                                    placeholder="Confirm Password"
                                                    value={password.confirmPassword}
                                                    onChange={handleChange}
                                                />
                                                <i className={conPasswordShown ? "input-group-text fa fa-eye" : "input-group-text fa fa-eye-slash"} id="basic-addon1" onClick={toggleConPassword}></i>
                                            </div>
                                        </div>

                                        <div className="container-login100-form-btn">
                                            <button type="button" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle btn-success" onClick={handleClick}>
                                                {CONFIRM}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ManualResetPassword;
